<template>
  <div>
    <px-view-header title="Compras" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"/>
    <div class="mt-5">
      <listagem-compra-header :on-click-refresh="onClickRefresh"
                              :on-change-filter="onChangeFilter"
                              @change="onChangeFilter"/>
      <lista-compra :compras="compras"
                    :loading="loading"
                    :on-change-options="onChangeOptions"
                    :options-list="optionsList"
                    @remove="onRemove"
                    @remove-rascunho="onRemoveRascunho"
                    @update="onClickRefresh"/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import paginationMixin from '@/mixins/pagination-mixin';
import ListaCompra from './ListaCompra.vue';
import ListagemCompraHeader from './ListagemCompraHeader.vue';
import CompraService from '../compra-service';

export default {
  mixins: [paginationMixin],
  data() {
    return {
      compras: {
        content: [],
        total: 0,
      },
      listOptions: {
        page: 1,
        limit: 10,
        offset: 0,
        filter: '',
        sort: 'dataCompra',
        sortDesc: true,
      },
      loading: false,
      breadcrumbs: [
        { text: 'Gestão de compras' },
        { text: 'Compras' },
      ],
      optionsList: {},
    };
  },
  computed: {
    ...mapGetters('listagemCompra', ['stringFilter']),
  },
  methods: {
    onChangeFilter() {
      this.listOptions.filter = this.stringFilter;
      this.resetPage();
      this.getCompras();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getCompras();
    },
    onClickRefresh() {
      this.getCompras();
    },
    onRemove(item) {
      this.loading = true;
      CompraService.remover(item.id)
        .then(() => {
          this.$toast('Compra removida com sucesso', { color: 'success' });
          this.getCompras();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onRemoveRascunho(item) {
      this.loading = true;
      CompraService.removerRascunho(item.id)
        .then(() => {
          this.$toast('Rascunho excluido com sucesso', { color: 'success' });
          this.getCompras();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resetPage() {
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getCompras() {
      this.loading = true;

      const { limit, offset } = this.listOptions;
      return CompraService.getCompras({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.compras = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  components: {
    ListaCompra,
    ListagemCompraHeader,
  },
  created() {
    this.optionsList = this.pageToOptions(this.listOptions);
    this.listOptions.filter = this.stringFilter;
  },
};
</script>
